<template>
    <MenuItemContainer :url="url"
                       class="article-container">
        <div class="img-container">
            <div v-if="isImageLoading"
                 class="purple-placeholder-loading placeholder-loading" />
            <img v-show="!isImageLoading"
                 class="article-image"
                 :src="image_url"
                 :alt="title"
                 :title="title"
                 @load="isImageLoading = false">
            <img v-if="subtype === ArticleSubtypeEnum.YOUTUBE"
                 class="play-button"
                 :src="asset_cdn('crypto/assets/video-button.png', 40)"
                 alt="YouTube Video Play Button"
                 title="YouTube Video Play Button">
        </div>
        <div class="article-text-container">
            <div class="article-title">
                {{ title }}
            </div>
            <div class="article-subtitle">
                {{ subtitle }}
            </div>
        </div>
    </MenuItemContainer>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import { asset_cdn } from '@/js/helpers/helpers';
    import MenuItemContainer from '../components/MenuItemContainer.vue';
    import { INavigationArticle } from '../types/menuTypes';
    import { ArticleSubtypeEnum } from '../enums/menuEnums';

    withDefaults(defineProps<INavigationArticle>(), {
        subtype: ArticleSubtypeEnum.DEFAULT,
    });

    const isImageLoading = ref(true);
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/partials/mixins" as mixins;

.article-container {
    display: flex;
    padding: 6px;

    .img-container {
        position: relative;
        height: 64px;
        margin-right: 8px;

        .article-image {
            height: 100%;
            border-radius: legacyVariables.$menu-border-radius;
        }

        .purple-placeholder-loading {
            width: 103px;
            height: 100%;
        }
    }

    .article-text-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 6px;
    }

    .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 35px;
        transform: translate(-50%, -50%);
    }

    .article-title {
        @include mixins.custom-line-clamp(3);
        min-width: 160px;
        font-size: 16px;
        font-weight: 500;
        line-height: 17px;

        @media (min-width: legacyVariables.$navigation-menu-breakpoint) {
            font-size: 13px;
        }
    }

    .article-subtitle {
        color: legacyVariables.$tutorial-date;
        font-size: 10px;
        font-weight: 500;
        line-height: 12px;
    }

    @media (max-width: 398px) {
        flex-direction: column;
        align-items: center;
        padding: 8px;
        text-align: center;

        .img-container {
            width: 250px;
            height: unset;

            .article-image {
                width: 100%;
            }
        }

        .article-title {
            margin-top: 8px;
            margin-bottom: 8px;
        }
    }
}

.mobile-nav {
    .article-image {
        height: 100px;
    }
}
</style>
